import Select from 'react-select'
import {ISelectOption} from '../../core/_model'

type Props = {
  value?: string
  options: ISelectOption[]
  handleSelect: (value: number) => void // To update state
}

const SelectEntriesOptions = ({value, options, handleSelect}: Props) => {
  return (
    <Select
      className='react-select-styled react-select custom-input w-100px'
      classNamePrefix='react-select'
      placeholder={value}
      value={options.find((option) => option.value === value)} // Bind value to state
      onChange={(selectedOption) => {
        if (selectedOption) {
          handleSelect(parseInt(selectedOption.value)) // Update parent state
        }
      }}
      options={options}
      isSearchable={false}
    />
  )
}

export default SelectEntriesOptions
